import { displayErrorMessage } from 'Helpers/FacetNotificationManager';

function buildModalQuery(name, modalOptions) {
  try {
    const base64EncodedOptions = btoa(JSON.stringify(modalOptions));
    return `${name}_${base64EncodedOptions}`;
  } catch (error) {
    displayErrorMessage(error, 'Failed to open modal');
    return null;
  }
}

export { buildModalQuery };
